<template>
  <section id="privacy">
    <div id="main" style="padding-top: 0px;">
      <div class="privacy-nav">
        <div class="container-my-help">
          <article class="container-my-help-article container-my-help-article-nav">
            <router-link to="/privacypolicy" @click.native="on('/privacypolicy')">{{$t('pp.nav')[0]}}</router-link>
            <router-link to="/dataprotectionnotice" @click.native="on('/dataprotectionnotice')">{{$t('pp.nav')[1]}}</router-link>
            <router-link to="/copyprivacypolicy" @click.native="on('/copyprivacypolicy')">{{$t('pp.nav')[2]}}</router-link>
          </article>
        </div>
      </div>
      <div class="privacypolicy container-my-help">
        <div class="privacypolicy-content container-my-help-article">
          <p class="font_1"
            v-html="$t('copy_pp.title0')"></p>

          <p class="font_8"><span><span style="font-weight:bold">&nbsp;</span></span></p>

          <p class="font_1"
            v-html="$t('copy_pp.tt0')"></p>
        </div>

        <div class="privacypolicy-content container-my-help-article">
          <p class="font_8"
            v-html="$t('copy_pp.p0_1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p0_2')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.tt1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p1_1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p1_2')"></p>

          <p class="font_8"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8 font_left"
            v-html="$t('copy_pp.list1')"></p>

          <p class="font_8"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8"
            v-html="$t('copy_pp.p1_3')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p1_4')"></p>

          <p class="font_8"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8"
            v-html="$t('copy_pp.tt2')"></p>

          <p class="font_8"><span style="text-decoration:underline"><span style="font-weight:bold"><span class="wixGuard">&ZeroWidthSpace;</span></span></span></p>

          <p class="font_8"
            v-html="$t('copy_pp.p2_1')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.list2')"></p>

          <p class="font_8 font_left"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8"
            v-html="$t('copy_pp.p2_2')"></p>

          <p class="font_8 font_left"
            v-html="$t('copy_pp.list2_2')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.p2_3')"></p>

          <p class="font_8"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8"
            v-html="$t('copy_pp.tt3')"></p>

          <p class="font_8"><span style="text-decoration:underline"><span style="font-weight:bold"><span class="wixGuard">&ZeroWidthSpace;</span></span></span></p>

          <p class="font_8"
            v-html="$t('copy_pp.p3_1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p3_2')"></p>

          <p class="font_8 font_left"
            v-html="$t('copy_pp.list3')"></p>

          <p class="font_8 font_left">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.p3_3')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.tt4')"></p>

          <p class="font_8"><span class="wixGuard">&ZeroWidthSpace;</span></p>

          <p class="font_8"
            v-html="$t('copy_pp.p4_1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p4_2')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p4_3')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.tt5')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p5_1')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.p5_2')"></p>

          <p class="font_8">&nbsp;</p>

          <p class="font_8"
            v-html="$t('copy_pp.tt6')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p6_1')"></p>

          <p class="font_8"
            v-html="$t('copy_pp.p6_2')"><br>
            &nbsp;</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import { Toast,Button,Popup } from 'vant'
// import PDF from '../../untils/pdf/pdf.vue';

export default {
  name: 'privacypolicycopy',
  inject: ['reload'],
  data () {return {}},
  mounted () {},
  methods: {}
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>

@keyframes opacityOut {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes opacityLevel {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#privacy {
  counter-reset: num;
  font-size: 17px;
  line-height: 26px;
  .privacy-nav {
    // padding: 0 0 0 10%;
    margin-bottom: 70px;
    background: #000;
    overflow: hidden;
    a {
      padding: 16px 16px;
      display: block;
      float: left;
      color: #fff;
      cursor: pointer;
      &:nth-of-type(1),
      &:nth-of-type(2) {
        &:hover {
          text-decoration: underline;
        }
      }
      &:nth-of-type(3) {
        text-decoration: underline;
      }
      // &:last-of-type {
      //   &:hover {
      //     text-decoration: none;
      //   }
      // }
    }
  }
}

.privacypolicy {
  width: 90% !important;
  &-content {
    .font_left {
      margin-left:40px;
      font-size:15px
    }
  }
}

.opacity-enter-active {
  animation: opacityOut 0.3s ease;
}
.opacity-leave-active {
  animation: opacityLevel 0.3s ease;
}

/deep/ a {
  display: inline-block !important;
  color: $color-1;
  &:hover {
    text-decoration: underline;
  }
}
.privacypolicy {
  margin: 60px auto;
  .bg {
    display: none;
  }
  .return {
    // position: absolute;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 16px;
    text-indent: 20px;
    color: $color-grey-1;
    em {
      margin-right: 10px;
      font-size: 16px;
    }
  }
  &-content {
    margin-bottom: 30px;
    .font_1 {
      font-size: 26px;
    }
    .font_8 {
      font-size: 18px;
      line-height: 28px;
    }
  }
}

@media (max-width: 1600px) {
  .privacypolicy {
    &-content {
      .font_1 {
        font-size: 24px;
      }
      .font_8 {
        font-size: 17px;
        line-height: 26px;
      }
    }
  }
}

@media (max-width: 1440px) {
}

@media (max-width: 1000px) {
  .privacypolicy {
    &-content {
      .font_1 {
        font-size: 20px;
      }
      .font_8 {
        font-size: 15px;
        line-height: 24px;
      }
      .font_left {
        margin-left: 15px;
        font-size: 15px
      }
    }
  }
}

@media (max-width: 768px) {
  .privacypolicy {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    width: 96% !important;
    .bg {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
      background: rgba(0, 0, 0, 0.8);
    }
    &-content {
      margin: 0;
      padding: 30px 16px 0;
    }
  }
  @media (max-width: 520px) {
    #privacy {
      .privacy-nav {
        a {
          padding: 10px 10px;
          font-size: 14px;
        }
      }
    }
  }
  @media (max-width: 410px) {
    #privacy {
      .privacy-nav {
        // padding: 0 0 0 1%;
        a {    
          padding: 12px 8px;
          font-size: 13px;
        }
      }
    }
  }
  @media (max-width: 377px) {
    .container-my-help-article-nav {
      margin-left: 2%;
      margin-right: 0%;
    }
    #privacy {
      .privacy-nav {
        // padding: 0 0 0 1%;
        a {
          padding: 12px 6px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/CopyPrivacyPolicy.vue